import React from 'react';
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import {InputAdornment} from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';

interface OwnProps {
    passwordShown: boolean;
    onClick: () => void;
}

type Props = OwnProps;
const PasswordShowHide = (props: Props) => {
    const {passwordShown} = props;
    return ( <InputAdornment style={{cursor:"pointer"}} position="end" onClick={props.onClick}>
            <IconButton style={{padding: "0px"}} onClick={props.onClick} size={"small"}>
            {passwordShown ?
                <VisibilityOffIcon color={"disabled"} fontSize={"small"}/>
                : <VisibilityIcon color={"disabled"} fontSize={"small"}/>}
            </IconButton>
    </InputAdornment>);
};

export default PasswordShowHide;
